import { Box, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';

import { PoolTypography } from '../pool-typography/pool-typography';

const StyledWrapper = styled(Box)(({ theme }) => ({
    width: '100%',
    height: 48,
    backgroundColor: theme.palette.text.primary,
    color: theme.palette.common.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

interface DetailSidebarHeaderProps {
    title: string;
}

export const DetailSidebarHeader = (props: DetailSidebarHeaderProps): ReactElement => (
    <StyledWrapper>
        <PoolTypography>
            <FormattedMessage id={props.title} />
        </PoolTypography>
    </StyledWrapper>
);
